var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_setup.showRooms ? _c('span', [_c(_setup.RoomOutput, {
    attrs: {
      "type": _vm.roomType,
      "input": _setup.rooms
    }
  })], 1) : _vm._e(), _vm._v(" "), _setup.hasArea ? _c('span', [_c(_setup.AreaOutput, {
    attrs: {
      "input": _setup.area
    }
  })], 1) : _vm._e(), _vm._v(" "), _setup.isEmpty ? _c('span', [_vm._v("\n    " + _vm._s(_vm.empty) + "\n  ")]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };